import Validatable from '@/validator/Validatable';

export interface IPostalCodesFileAPI {
  postalcodesfile_id: number;
  organization_id: number;
  file_name: string;
  s3_key: string;
  url: string;
  created_on_utc: string;
  modified_on_utc: string;
}

export default class PostalCodesFile extends Validatable<number> {
  constructor(
    public id: number = -1,
    public organizationID: number = null,
    public fileName: string = null,
    public s3Key: string = null,
    public url: string = null,
    public createdOnUtc: string = null,
    public modifiedOnUtc: string = null,
  ) {
    super();
    this.id = id;
    this.organizationID = organizationID;
    this.fileName = fileName;
    this.s3Key = s3Key;
    this.url = url;
    this.createdOnUtc = createdOnUtc;
    this.modifiedOnUtc = modifiedOnUtc;
  }

  get fileDownloadLink(): string {
    return this.url ? `<a href="${this.url}" target="_blank">Download</a>` : '';
  }

  get createdOnFormatted(): string {
    return new Date(this.createdOnUtc).toLocaleString();
  }

  get modifiedOnFormatted(): string {
    return new Date(this.modifiedOnUtc).toLocaleString();
  }

  static fromApi(apiObject: IPostalCodesFileAPI): PostalCodesFile {
    return new PostalCodesFile(
      apiObject.postalcodesfile_id,
      apiObject.organization_id,
      apiObject.file_name,
      apiObject.s3_key,
      apiObject.url,
      apiObject.created_on_utc,
      apiObject.modified_on_utc,
    );
  }

  toApi(): IPostalCodesFileAPI {
    return {
      postalcodesfile_id: this.id >= 0 ? this.id : undefined,
      organization_id: this.organizationID,
      file_name: this.fileName,
      s3_key: this.s3Key,
      url: this.url,
      created_on_utc: this.createdOnUtc,
      modified_on_utc: this.modifiedOnUtc,
    };
  }
}
